var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12,"offset":6}},[_c('div',{staticClass:"content-area-txt-tab"},[_vm._v(" Bring your production team and audience together in real-time.TVU Partyline is the industry’s only real-time, ultra-low latency, ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }